import { sy_arrow_chevron_left as chevronLeftIcon } from '@aab/sc-aab-icon-set';
import { Button, Grid, Icon, Modal, Typography } from '@uikit';
import { redirect } from '@utils';
import classnames from 'classnames';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './navigation.module.scss';

export const Navigation: FC = () => {
  const { t } = useTranslation('', { keyPrefix: 'navigation' });
  const modalRef = useRef<ModalHTMLElement>(null);

  return (
    <>
      <nav className={classnames(classes.nav, 'flex ', 'ai-center')}>
        <Grid.Container>
          <Grid.Column
            className={classnames(
              classes.titleContainer,
              'flex',
              'jc-center',
              'ai-start',
              'dir-column'
            )}>
            <button
              type="button"
              onClick={() => modalRef?.current?.openModal()}>
              <Typography
                variant="body"
                color="white"
                className={classnames(
                  classes.internetBanking,
                  'mb-0',
                  'flex',
                  'ai-center'
                )}>
                <Icon svg={chevronLeftIcon} size={3} color="white" />
                {t('internetBanking')}
              </Typography>
            </button>
            <Typography variant="h2" color="white" className="mb-0">
              {t('currencyExchange')}
            </Typography>
          </Grid.Column>
        </Grid.Container>
      </nav>
      <Modal
        ref={modalRef}
        title={
          <Typography variant="h3" className="mb-0">
            {t('modal.title')}
          </Typography>
        }
        content={<Typography className="mb-0">{t('modal.content')}</Typography>}
        footer={
          <>
            <Button
              styleType="secondary"
              onClick={(e) => modalRef?.current?.closeModal(e)}>
              {t('modal.cancel')}
            </Button>
            <Button className="ml-1" onClick={redirect.redirectToIBB}>
              {t('modal.action')}
            </Button>
          </>
        }
      />
    </>
  );
};
